import { Grid } from "@mui/material";
import React from "react";
import GraphHeader from "../../graphs/GraphHeader";
import { formatOutput } from "../../../utils/computation/analysis";

function DescriptiveStatsResult({ stats }) {
  return (
    <div>
      <GraphHeader
        column={stats.column}
        dateTime={stats.dateTime}
        title={"Descriptive Statistics"}
        analysisId={stats.id}
      />
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ color: "#535353" }}
      >
        {stats.Checklist.isCount && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>N</h4>
            <h3>{stats.descriptiveStatistics.count}</h3>
          </Grid>
        )}
        {stats.Checklist.isMean && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>Mean</h4>
            <h3>{formatOutput(stats.descriptiveStatistics.mean)}</h3>
          </Grid>
        )}
        {stats.Checklist.isStd && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>StDev</h4>
            <h3>{formatOutput(stats.descriptiveStatistics.std)}</h3>
          </Grid>
        )}
        {stats.Checklist.isMin && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>Min</h4>
            <h3>{formatOutput(stats.descriptiveStatistics.min)}</h3>
          </Grid>
        )}
        {stats.Checklist.is25Percentile && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>25th Percentile</h4>
            <h3>{formatOutput(stats.descriptiveStatistics["25%"])}</h3>
          </Grid>
        )}
        {stats.Checklist.is50Percentile && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>50th Percentile</h4>
            <h3>{formatOutput(stats.descriptiveStatistics["50%"])}</h3>
          </Grid>
        )}
        {stats.Checklist.is75Percentile && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>75th Percentile</h4>
            <h3>{formatOutput(stats.descriptiveStatistics["75%"])}</h3>
          </Grid>
        )}
        {stats.Checklist.isMax && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>Max</h4>
            <h3>{formatOutput(stats.descriptiveStatistics.max)}</h3>
          </Grid>
        )}

        {stats.Checklist.isMedian && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>Median</h4>
            <h3>{formatOutput(stats.median)}</h3>
          </Grid>
        )}
        {stats.Checklist.isMode && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>Mode</h4>
            <h3>{formatOutput(stats.mode)}</h3>
          </Grid>
        )}
        {stats.Checklist.isSkew && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>Skew</h4>
            <h3>{formatOutput(stats.skew)}</h3>
          </Grid>
        )}
        {stats.Checklist.isKurtosis && (
          <Grid item xs={2} sm={3} md={3}>
            <h4>Kurtosis</h4>
            <h3>{formatOutput(stats.kurtosis)}</h3>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default DescriptiveStatsResult;
